import BaseRepository from "./BaseRepository";
import ProfileAPICall from "../service/ProfileAPICall";

class ProfileRepository extends BaseRepository {
    getProfileAccountInformation = async () => {
        return await new ProfileAPICall().getProfileAccountInformation();
    };
}

export default ProfileRepository;